import { usePageMeta } from "@/lib/meta";
import { HtmlBlock } from "@/components/HtmlBlock";
import html from "@/gen/model";

export default function ModelPage() {
  usePageMeta("The Model");
  return <HtmlBlock html={html} testId="model-page" />;
}
